import {
  GET_REGISTRATION_FORMS_REQUEST,
  GET_REGISTRATION_FORMS_SUCCESS,
  GET_REGISTRATION_FORMS_FAILED,
  DELETE_REGISTRATION_FORMS_SUCCESS,
  DELETE_REGISTRATION_FORMS_REQUEST,
  DELETE_REGISTRATION_FORMS_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const registrationFormsReducer = (state = initialState, {
  type, error, data, meta, deletedId,
}) => {
  switch (type) {
    case GET_REGISTRATION_FORMS_REQUEST:
      return { ...state, loading: true };
    case GET_REGISTRATION_FORMS_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_REGISTRATION_FORMS_FAILED:
      return { ...state, loading: false, error };
    case DELETE_REGISTRATION_FORMS_REQUEST:
      return { ...state, loading: true };
    case DELETE_REGISTRATION_FORMS_SUCCESS:
      return {
        ...state,
        data: state.data.filter((form) => form.id !== deletedId),
        loading: false,
      };
    case DELETE_REGISTRATION_FORMS_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default registrationFormsReducer;
